import { forwardRef, FC, useState, useEffect } from 'react';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Models
import { IOption_V2 } from 'app/models/Option';
// Selectors
import { selectEpisodeLabelsAsOptions } from 'app/store/Episodes/Episodes.selectors';
// Mui
import { Chip, Autocomplete, TextField } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';
// Utilities
import { generateAttrForTesting } from 'app/utilities/Utilities';

type Props = {
  value: string[];
  onChange: (nextValue:any[]) => void;

  size?: any;
  margin?: any;
}

const AutocompleteLabels:FC<Props> = forwardRef(({
  // Props
  value, onChange, size, margin = 'normal'
}, ref) => {
  const { t } = useTranslation();
  // State
  const options = useAppSelector(selectEpisodeLabelsAsOptions);

  const [ selectedOptions, setSelectedOptions ] = useState<IOption_V2[]>([]);

  // useEffect(() => {
  //   return () => {
  //     setSelectedOptions([]);
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if ( value.length && options ){
      const filteredOptions = options.filter((option:IOption_V2) => value.includes(option.value));
      setSelectedOptions(filteredOptions);
    } else {
      setSelectedOptions([]);
    }
    // eslint-disable-next-line
  }, [value]);

  const handleChange = (_:any, nextValue:IOption_V2[] | undefined) => {
    setSelectedOptions(nextValue || []);
    onChange(nextValue ? nextValue.map((option:IOption_V2) => option.value) : []);
  }

  return (
    <Autocomplete
      {...generateAttrForTesting('control', 'autocomplete', 'labels')}
      value={selectedOptions}
      disabled={!options}
      onChange={handleChange}
      options={options || []}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('labels.labels')}
          margin={margin}
          fullWidth
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>{option.label}</li>
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            sx={{ maxWidth: '160px' }}
            key={option.value}
            label={option.label}
            title={option.label}
            size={size}
          />
        ))
      }
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, { value }) => option.value === value}
      fullWidth
      multiple
      limitTags={3}
      filterSelectedOptions

      ListboxProps={{...generateAttrForTesting('element', 'list', 'labels')}}
    />
  )
})

export default AutocompleteLabels;
